import { motion } from "framer-motion";
import { SERVICES } from "@/data/content";

const row = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 },
  }),
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="px-6 md:px-12 py-24 md:py-36 bg-white border-y border-hairline"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-14">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-forest">
            (02) — What we do
          </span>
          <h2 className="mt-4 font-display font-extrabold text-ink tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl max-w-[18ch]">
            Six ways we win you organic traffic.
          </h2>
        </div>

        <div className="border-t border-ink/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              custom={i}
              variants={row}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              data-testid={`service-row-${s.id}`}
              className="group grid grid-cols-12 items-center gap-4 border-b border-ink/10 py-7 md:py-9 cursor-default hover:bg-paper transition-colors duration-400"
            >
              <div className="col-span-2 md:col-span-1 font-mono text-sm text-ink/40">
                0{i + 1}
              </div>
              <h3 className="col-span-10 md:col-span-4 font-display font-bold text-2xl md:text-3xl tracking-tight text-ink group-hover:text-forest transition-colors duration-300">
                {s.title}
              </h3>
              <p className="col-span-12 md:col-span-6 md:col-start-6 text-ink/55 text-base leading-relaxed md:pl-6">
                {s.desc}
              </p>
              <div className="hidden md:flex md:col-span-1 justify-end">
                <span className="text-2xl text-ink/30 group-hover:text-forest group-hover:translate-x-1 transition-all duration-300">
                  →
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
